import apiClient from './api';
import { PlansResponse } from '../types/pricing';

class PricingService {
  async fetchPlans(): Promise<PlansResponse> {
    const { data } = await apiClient.get<PlansResponse>('/api/platform/plans');
    return data;
  }
}

export default new PricingService();
